import * as React from 'react';

import { createIcon } from '../Icon';
export const CircleIcon = createIcon(
  <circle cx={12} cy={12} r={10} />,
  'CircleIcon'
);
